import { useEffect, useRef } from "react";

const useEffectWithoutMount = (effectCallback: Function, dependencies: Array<any>) => {
  //remember the mount-time dependencies instead of counting invocations: StrictMode
  //double-invokes mount effects, so a boolean "first run" ref would let the second
  //invocation run the callback on mount anyway
  const mountDependenciesRef = useRef<Array<any> | null>(null);
  if (mountDependenciesRef.current === null) {
    mountDependenciesRef.current = dependencies;
  }

  useEffect(() => {
    const mountDependencies = mountDependenciesRef.current;
    if (mountDependencies && dependencies.every((dependency, index) => Object.is(dependency, mountDependencies[index]))) {
      return;
    }
    //after the first real change, run on every later change (even back to mount values)
    mountDependenciesRef.current = null;
    return effectCallback();
  }, dependencies);
};

export default useEffectWithoutMount;
